import type { GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'

export function displayLabel(field: GeneratedSchemaField): string {
  return typeof field.label === 'string' && field.label.trim()
    ? field.label
    : typeof field.name === 'string'
      ? field.name
      : 'Field'
}
